import React from "react";
import styled from "styled-components";
import { ClipLoader } from "react-spinners";

const Button = styled.button`
  background-color: ${(props) => props.theme.mainColor};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5), inset 0px 0px 20px rgba(255, 247, 217, 0.3);
  border-radius: 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 26px;
  color: white;
  /* identical to box height */

  padding: 7px 10px;

  text-align: center;

  :hover {
    opacity: 0.5;
  }
  :focus {
    outline: none;
  }
  border: 0;
`;

const BlockButton = styled(Button)`
  width: 100%;
`;

const DefaultButton = ({
  style = {},
  onClick = () => null,
  text = "null",
  type = "button",
  disabled = false,
  block = false,
}) => {
  return block ? (
    <BlockButton style={style} onClick={disabled ? () => null : onClick} type={type}>
      {disabled ? <ClipLoader sizeUnit={"px"} size={15} color={"white"} /> : text}
    </BlockButton>
  ) : (
    <Button style={style} onClick={disabled ? () => null : onClick} type={type}>
      {disabled ? <ClipLoader sizeUnit={"px"} size={15} color={"white"} /> : text}
    </Button>
  );
};

export default DefaultButton;
